import React from "react";
import styled from "styled-components";

const Wrapper = styled.section`
    width: 100%;
    padding: 40px 20px;
    background-color: #e0e0e0;
    box-sizing: border-box;
`;

const Heading = styled.h2`
    text-align: center;
    font-size: 30px;
    margin-bottom: 30px;
    color: #4a4a4a;
    font-weight: bold;
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 20px;
    justify-content: center;
`;

const Card = styled.div`
    background-color: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    max-width: 320px;
    flex: 1;
    min-width: 280px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
        transform: translateY(-6px);
        box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
    }
`;

const Image = styled.img`
    width: 100%;
    height: 200px;
    object-fit: cover;
`;

const Content = styled.div`
    padding: 20px;
`;

const Title = styled.h3`
    font-size: 20px;
    margin-bottom: 10px;
    color: #4a4a4a;
    font-weight: 500;
`;

const Date = styled.p`
    font-size: 14px;
    color: #777;
    margin-bottom: 10px;
`;

const Excerpt = styled.p`
    font-size: 16px;
    color: #444;
    line-height: 1.5;
    margin-bottom: 15px;
`;

const Button = styled.a`
    display: inline-block;
    padding: 10px 20px;
    background-color: #4a4a4a;
    color: #fff;
    text-decoration: none;
    border-radius: 4px;
    font-size: 16px;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: #666;
    }
`;

const posts = [
  {
    image: "blog1.jpg",
    title: "Neue digitale Plattform gestartet",
    date: "15. April 2025",
    excerpt:
      "Troniq.news präsentiert seine neue digitale Plattform, die darauf ausgelegt ist, das Benutzererlebnis zu revolutionieren und Geschäftsprozesse zu optimieren.",
    link: "#"
  },
  {
    image: "blog2.jpg",
    title: "KI-Innovationen",
    date: "10. April 2025",
    excerpt:
      "Erfahren Sie, wie unsere neuesten KI-Innovationen die Art und Weise verändern, wie Unternehmen im digitalen Zeitalter arbeiten.",
    link: "#"
  },
  {
    image: "blog3.jpg",
    title: "Strategische Partnerschaften für Wachstum",
    date: "5. April 2025",
    excerpt:
      "Wir haben neue strategische Partnerschaften aufgebaut, die unser Wachstum fördern und Geschäftsmöglichkeiten im Technologiesektor erweitern werden.",
    link: "#"
  }
];

const BlogComponent = () => {
  return (
    <Wrapper>
      <Heading>Neueste Nachrichten</Heading>
      <Grid>
        {posts.map((post, index) => (
          <Card key={index}>
            <Image src={post.image} alt={post.title} />
            <Content>
              <Title>{post.title}</Title>
              <Date>{post.date}</Date>
              <Excerpt>{post.excerpt}</Excerpt>
              <Button href={post.link}>Mehr erfahren</Button>
            </Content>
          </Card>
        ))}
      </Grid>
    </Wrapper>
  );
};

export default BlogComponent;